export function saveAlbums(state, albums) {
  state.albums = albums;
}
